

<div>
<!-- Onglets -->
  <div class="flex">
    <button
      (click)="activeTab = 'buy'"
      class="px-6 py-3 font-medium transition rounded-t-lg"
      [ngClass]="activeTab === 'buy'
        ? 'bg-secondary-600 dark:bg-dark text-white'
        : 'bg-secondary-500 dark:bg-dark-200 text-gray-200'">
      <!--i18n - Order  -->
      {{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.button_01' | translate }}
    </button>

    <button
      (click)="activeTab = 'tracking'"
      class="px-6 py-3 font-medium transition rounded-t-lg ml-1"
      [ngClass]="activeTab === 'tracking'
        ? 'bg-secondary-600 dark:bg-dark text-white'
        : 'bg-secondary-500 dark:bg-dark-200 text-gray-200'"
        >
      
      <!--i18n - Order  -->
      {{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.button_02' | translate }}
    </button>
  </div>


<!-- Encart -->
  <div class="bg-secondary-600 dark:bg-[#0c1427] shadow-xl rounded-b-xl rounded-tr-xl p-6 min-h-[350px] flex flex-col">
    @if (activeTab === 'buy') {
        <app-fp-currency-purchase></app-fp-currency-purchase>
    }

    @if (activeTab === 'tracking') {
      <app-fp-order-tracking></app-fp-order-tracking>
    }


  </div>

</div>




                

            
                    